import { Box, Menu, MenuItem, MenuList, Portal, Text } from '@chakra-ui/react'
import React, { useEffect } from 'react'

import { Icon } from '../Icons/Icon'

interface ContextMenuProps {
  isOpen: boolean
  x: number
  y: number
  onClose: () => void
  onCopyCell: () => void
  onCopyRow: () => void
}

export const ContextMenu: React.FC<ContextMenuProps> = ({
  isOpen,
  x,
  y,
  onClose,
  onCopyCell,
  onCopyRow,
}) => {
  useEffect(() => {
    const handleClick = () => {
      if (isOpen) onClose()
    }
    document.addEventListener('click', handleClick)
    return () => document.removeEventListener('click', handleClick)
  }, [isOpen, onClose])

  if (!isOpen) return null

  return (
    <Portal>
      <Box
        position="fixed"
        top={y}
        left={x}
        zIndex={1400}
        onContextMenu={e => {
          e.preventDefault()
          onClose()
        }}
      >
        <Menu isOpen={true} onClose={onClose}>
          <MenuList
            minWidth="220px"
            boxShadow="0px 4px 12px rgba(0, 0, 0, 0.15)"
            borderRadius="8px"
            py={2}
            border="none"
          >
            <MenuItem
              onClick={onCopyCell}
              icon={
                <Icon
                  icon="CopyPasteIcon"
                  boxSize="18px"
                  color="presets.neutral.100"
                />
              }
              _hover={{ bg: 'presets.neutral.10' }}
              py={2}
              px={4}
            >
              <Text
                fontSize="14px"
                fontWeight={500}
                color="presets.neutral.100"
              >
                Copy
              </Text>
            </MenuItem>
            <MenuItem
              onClick={onCopyRow}
              icon={
                <Icon
                  icon="CopyPasteIcon"
                  boxSize="18px"
                  color="presets.neutral.100"
                />
              }
              _hover={{ bg: 'presets.neutral.10' }}
              py={2}
              px={4}
            >
              <Text
                fontSize="14px"
                fontWeight={500}
                color="presets.neutral.100"
              >
                Copy Row With Headers
              </Text>
            </MenuItem>
          </MenuList>
        </Menu>
      </Box>
    </Portal>
  )
}
